import script from "./CouponListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CouponListItem.vue?vue&type=script&setup=true&lang=ts"

import "./CouponListItem.vue?vue&type=style&index=0&id=10ef6834&lang=css"

const __exports__ = script;

export default __exports__